import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function LoadListMapSpatialPopup( props ) {
    //console.debug("RTS Break LoadListMapSpatialPopup");

    const ld = props.data;
    const serNum = ld.reelSerialNumber==null?'':ld.reelSerialNumber;
    const projectName = ld.projectIdGuid != null && ld.projectIdGuid !== '00000000-0000-0000-0000-000000000000'?ld.projectName:'No Project';
    const remains = Math.floor(ld.amt - ld.curPullSum);


    function handleClick(){
        props.onItemClick(ld.idGuid);
    }


    return(
        <Box>
            <Typography variant='h6'>Reel: {serNum}</Typography>
            <Box sx={{display:'flex'}}>
                <Box>
                    <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Product:</Typography>
                </Box>
                <Box>
                    <Typography variant='caption'>{ld.curAliasName + " (" + ld.curAliasNumber + ")"}</Typography>
                </Box>
            </Box>
            <Box>
                <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Remaining:</Typography>
                <Typography variant='caption'>{remains.toLocaleString(undefined, { maximumFractionDigits: 2 })} ft</Typography>
            </Box>
            <Box>
                <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Purchase Order:</Typography>
                <Typography variant='caption'>{ld.customerPo}</Typography>
            </Box>
            <Box>
                <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Project:</Typography>
                <Typography variant='caption'>{projectName}</Typography>
            </Box>
            <Box>
                <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Ship Date:</Typography>
                <Typography variant='caption'>{(new Date(ld.shipDate)).toLocaleDateString("en-US")}</Typography>
            </Box>


            <Box>
                <Typography variant='caption' sx={{fontWeight:'bold', mr:1}}>Deferral:</Typography>
                {
                    ld.deferralPeriod > 0
                    ?
                        ld.deferralDaysLeft>90
                        ?
                            <Typography variant='caption' sx={{color:'green'}}>{ld.deferralDaysLeft + ' Days Remaining'}</Typography>
                        :
                            ld.deferralDaysLeft>60
                            ?
                                <Typography variant='caption' sx={{color:'gold'}}>{ld.deferralDaysLeft + ' Days Remaining'}</Typography>
                            :
                                ld.deferralDaysLeft>30
                                ?
                                    <Typography variant='caption' sx={{color:'orange'}}>{ld.deferralDaysLeft + ' Days Remaining'}</Typography>
                                :
                                    ld.deferralDaysLeft>=0
                                    ?
                                        <Typography variant='caption' sx={{color:'red'}}>{ld.deferralDaysLeft + ' Days Remaining'}</Typography>
                                    :
                                        <Typography variant='caption' sx={{color:'red'}}>{(ld.deferralDaysLeft *-1) + ' Days Overdue'}</Typography>
                    :
                        <Typography variant='caption' sx={{color:'green'}}>{ld.deferralDaysLeft + ' Days On Site'}</Typography>
                }
            </Box>
            <Box>
                <Link onClick={handleClick} sx={{textDecoration:'none', cursor:'pointer', width:'100%'}}>
                    <Box sx={{display:'flex', justifyContent:'center', mt:1}}>
                        <InfoOutlinedIcon />
                        <Typography sx={{fontWeight:'bold', pl:'2px'}}>Show Details</Typography>
                    </Box>
                </Link>
            </Box>
        </Box>
    );

}
